export const ADD_FEES_COLLECTION_REQUEST = 'ADD_FEES_COLLECTION_REQUEST'
export const ADD_FEES_COLLECTION_SUCCESS = 'ADD_FEES_COLLECTION_SUCCESS'
export const ADD_FEES_COLLECTION_FALIURE = 'ADD_FEES_COLLECTION_FALIURE'
